import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { formatDate } from "../common/DateHelper";


export interface EncounterListProps {
    encounters: APIStore.Encounter[] | null,
    isLoading: boolean
}


const EncounterList = (props: EncounterListProps) => {
    let { encounters, isLoading } = props;

    if(isLoading) {
        return (
            <div>
                <Typography variant="body1" component="div" gutterBottom>

                    <div className="skeleton skeleton-text">
                        <p>&#8239;&#8239;&#8239;&#8239;</p>
                    </div>
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>

                    <div className="skeleton skeleton-text">
                        <p>&#8239;&#8239;&#8239;&#8239;</p>
                    </div>
                </Typography>
                <Typography variant="body1" component="div" gutterBottom>

                    <div className="skeleton skeleton-text">
                        <p>&#8239;&#8239;&#8239;&#8239;</p>
                    </div>
                </Typography>
            </div>)
    }

    return (
        <div>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>Admission History:</strong>
            </Typography>
            <TableContainer >
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Facility</TableCell>
                            <TableCell align="right">Admitted</TableCell>
                            <TableCell align="right">Discharged</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {encounters.map((val) => (
                            <TableRow>
                                <TableCell component="th" scope="row">
                                    {val.facility.facilityName}
                                </TableCell>
                                <TableCell align="right">
                                    {formatDate(val.encounterStart, true)}

                                </TableCell>
                                <TableCell align="right">

                                    {formatDate(val.encounterEnd, true)}


                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}


export default EncounterList;
